<!-- 特権管理タブ -->
<div class="privilege-management">

    <!-- 横並びコンテナ: 社員管理レベルの変更 + 社員管理者一覧と履歴 -->
    <div class="main-container">
        
        <!-- 社員管理レベルの変更 -->
        <div class="privilege-change-section">
            <h3>社員管理レベルの変更</h3>

            <!-- メールアドレス検索 -->
            <div class="search-row">
                <label>メールアドレス</label>
                <input type="email" 
                       [(ngModel)]="searchEmail"
                       placeholder=""
                       class="email-input">
                <button type="button" 
                        (click)="searchUser()"
                        class="btn btn-secondary">表示</button>
            </div>

            <!-- エラーメッセージ表示 -->
            <div *ngIf="searchErrorMessage" class="error-message">
                {{ searchErrorMessage }}
            </div>

            <!-- 社員情報表示 -->
            <div *ngIf="selectedUser" class="user-info-box">
                <div class="user-info-row">
                    <span class="label">社員氏名:</span>
                    <span class="value">{{selectedUser.userName}}</span>
                    <span class="label">PB ID:</span>
                    <span class="value">{{selectedUser.repID}}</span>
                    <span class="label">社員番号:</span>
                    <span class="value">{{selectedUser.repNumber}}</span>
                    <label class="checkbox-label">
                        <input type="checkbox" [checked]="selectedUser.readWrite" disabled>
                        書込み権限
                    </label>
                </div>
                <div class="user-info-row">
                    <label class="checkbox-label">
                        <input type="checkbox" [(ngModel)]="selectedUser.enabled" disabled>
                        有効
                    </label>
                    <label class="checkbox-label">
                        <input type="checkbox" [(ngModel)]="selectedUser.approver" disabled>
                        承認者
                    </label>
                    <label class="checkbox-label">
                        <input type="checkbox" [(ngModel)]="selectedUser.manager" disabled>
                        担当者
                    </label>
                    <span class="label">管理者レベル:</span>
                    <span class="value">{{selectedUser.adminLevel}}</span>
                    <span class="label">最終更新日時:</span>
                    <span class="value">{{selectedUser.createDate}}</span>
                </div>
            </div>

            <!-- 管理者レベル変更フォーム -->
            <div *ngIf="selectedUser" class="level-change-form">
                <div class="form-row">
                    <label class="form-label">管理者レベル</label>
                    <select [(ngModel)]="newManagementLevel" class="level-select">
                        <option *ngFor="let level of availableLevels" [value]="level">レベル{{level}}管理者</option>
                    </select>
                    <label class="checkbox-label write-permission">
                        <input type="checkbox" [(ngModel)]="isEmergencyApplication">
                        書込み権限
                    </label>
                </div>
                <div class="form-row">
                    <label class="form-label">変更申請SR番号</label>
                    <input type="text" 
                           [(ngModel)]="srNumber"
                           placeholder=""
                           class="sr-input">
                    <button type="button" 
                            (click)="updateUserLevel()"
                            class="btn btn-primary">変更</button>
                </div>
            </div>

            <!-- 管理者レベルについて -->
            <div class="level-info-section">
                <h4>管理者レベルについて</h4>
                <table class="level-info-table">
                    <thead>
                        <tr>
                            <th>レベル</th>
                            <th>種類</th>
                            <th>可能な操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="center">1</td>
                            <td>PBのID保持者</td>
                            <td>アクセス不可、ただし特権IDの申請が可能</td>
                        </tr>
                        <tr>
                            <td class="center">2</td>
                            <td>承認者または担当者</td>
                            <td>自身の担当タイムシートの管理</td>
                        </tr>
                        <tr>
                            <td class="center">3</td>
                            <td>特権管理者</td>
                            <td>全支店のタイムシートの管理</td>
                        </tr>
                        <tr>
                            <td class="center">4</td>
                            <td>オペレーション担当者</td>
                            <td>レベル３機能 + 獲注・タイムシート変更管理</td>
                        </tr>
                        <tr>
                            <td class="center">5</td>
                            <td>サポートデスク担当者</td>
                            <td>レベル３機能 + 特権ID管理</td>
                        </tr>
                        <tr>
                            <td class="center">9</td>
                            <td>システム管理者</td>
                            <td>レベル４/５機能 + システム管理</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- 右側のコンテナ: 社員管理者一覧 + 管理レベル変更履歴 -->
        <div class="right-container">
            <!-- 社員管理者一覧 -->
            <div class="managers-list-section">
                <h3>社員管理者一覧</h3>
                <div class="filter-row">
                    <span class="filter-label">レベル:</span>
                    <label class="filter-checkbox"><input type="checkbox" [(ngModel)]="filterLevel1"> 1</label>
                    <label class="filter-checkbox"><input type="checkbox" [(ngModel)]="filterLevel2"> 2</label>
                    <label class="filter-checkbox"><input type="checkbox" [(ngModel)]="filterLevel3"> 3</label>
                    <label class="filter-checkbox"><input type="checkbox" [(ngModel)]="filterLevel4"> 4</label>
                    <label class="filter-checkbox"><input type="checkbox" [(ngModel)]="filterLevel5"> 5</label>
                    <label class="filter-checkbox"><input type="checkbox" [(ngModel)]="filterLevel9"> 9</label>
                    <button type="button" class="btn btn-csv" (click)="exportManagersCSV()">CSV出力</button>
                </div>

                <!-- エラーメッセージ表示 -->
                <div *ngIf="filterErrorMessage" class="error-message">
                    {{ filterErrorMessage }}
                </div>
            </div>

            <!-- 管理レベル変更履歴 -->
            <div class="history-section">
                <h3>管理レベル変更履歴</h3>
                <div class="history-filter-row">
                    <label>年</label>
                    <select [(ngModel)]="selectedYear" class="year-select">
                        <option *ngFor="let year of yearOptions" [value]="year">{{ year }}年</option>
                    </select>
                    <button type="button" class="btn btn-csv" (click)="exportHistoryCSV()">CSV出力</button>
                </div>
            </div>

            <!-- ロボット用ID登録 -->
            <div class="robot-id-section">
                <h3>ロボット用ID登録</h3>
                <div class="robot-id-form">
                    <div class="robot-form-row">
                        <label>LoginID</label>
                        <input type="text" [(ngModel)]="robotLoginId" class="robot-input" autocomplete="off">
                        <div class="robot-buttons">
                            <button type="button" class="btn btn-secondary" (click)="deleteRobotId()">削除</button>
                            <button type="button" class="btn btn-primary" (click)="registerRobotId()">登録</button>
                        </div>
                    </div>
                    <div class="robot-form-row">
                        <label>登録申請SR番号</label>
                        <input type="text" [(ngModel)]="robotSrNumber" class="robot-input" autocomplete="off">
                        <div class="robot-buttons">
                            <button type="button" class="btn btn-secondary" (click)="loadRobotIdList()">一覧表示</button>
                        </div>
                    </div>
                </div>
                <div *ngIf="robotErrorMessage" class="error-message">{{ robotErrorMessage }}</div>
                <div *ngIf="showRobotIdList" class="robot-id-list">
                    <table class="robot-id-table">
                        <thead>
                            <tr>
                                <th>LoginID</th>
                                <th>登録日</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of robotIds">
                                <td>{{ item.loginId }}</td>
                                <td>{{ item.registeredDate | date:'yyyy/MM/dd' }}</td>
                            </tr>
                            <tr *ngIf="robotIds.length === 0">
                                <td colspan="2" class="center">データがありません</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- 右側コンテナ終了 -->
        
    </div>
    <!-- 横並びコンテナ終了 -->
</div>
